export const iconMap = {
  ADJUDICATION_ICON: 'adjudication',
  ALARM_ICON: 'alarm',
  ALERT_ICON: 'alert',
  ARROW_DOWN_ICON: 'arrow-down',
  ARROW_LEFT_ICON: 'arrow-left',
  ARROW_RIGHT_ICON: 'arrow-right',
  ARROW_UP_ICON: 'arrow-up',
  ATM_MONEY_ARROW_ICON: 'atm-money-arrow',
  BELL_NOTIFICATION_ARROW_ICON: 'bell-notifications',
  BROWSER_WEB_LOADING_ICON: 'browser-web-loading',
  BUILDING_CITY_TOWN_ICON: 'building-city-town',
  CALENDAR_ICO_ICON: 'calendar-icon',
  CALENDAR_SCHEDULE_ICON: 'calendar-schedule',
  CALENDAR_ICON: 'calendar',
  CHECK_ICON: 'check',
  CHEVRON_DOWN_ICON: 'chevron-down',
  CHEVRON_UP_ICON: 'chevron-up',
  CHEVRON_LEFT_ICON: 'chevron-left',
  CIRCLE_ICON: 'circle',
  CLAIM_AGE_ICON: 'claim-age',
  CLAIM_SET_ICON: 'claim-set',
  CLAIM_LIST_ICON: 'claim-list',
  CLAIM_ICON: 'claim',
  CLOSE_ICON: 'close',
  COGWHEEL_ICON: 'cogwheel',
  CONTACT_ICON: 'contact',
  CONTINGENT_ICON: 'contingent',
  CREDIT_CARDS_ICON: 'credit-cards',
  DASHBOARD_CLOCK_SQUARE_ICON: 'dashboard-clock-square',
  DASHED_BORDER_ICON: 'dashed-border',
  DATE_PICKER_CALENDAR_ICON: 'date-picker-calendar',
  DEATH_ICON: 'death-icon',
  DELETE_ICON: 'delete-icon',
  DELIVERY_CALENDAR_ICON: 'delivery-calendar',
  DOCUMENTS_FILE_CHECK_ICON: 'documents-file-check',
  DOCUMENTS_FILE_CHECKMARK_ICON: 'documents-file-checkmark',
  DOCUMENTS_FILE_COPY_ICON: 'documents-file-copy',
  DOCUMENTS_FILE_HEART_ICON: 'documents-file-heart',
  DONE_CHECK_CIRCLE_ICON: 'done-check-circle',
  DONE_CHECK_ICON: 'done-check',
  DONE_ICON: 'done',
  DOWN_ICON: 'down',
  DOWNLOAD_ARROW_ICON: 'download-arrow',
  DOWNLOAD_ARROW_BOLD_ICON: 'download-arrow-bold',
  DRAG_AND_DROP_ICON: 'drag-and-drop',
  DUE_DATE_ICON: 'due-date',
  EDIT_MODE_MESSAGE_ICON: 'edit-mode-message',
  EMAIL_ICO_ICON: 'email-icon',
  EMAIL_ICON: 'email',
  EMAILS_SHARE_ICON: 'emails-share',
  EMPTY_SEARCH_LIGHT_ICON: 'empty-search-light',
  EMPTY_USER_SEARCH_ICON: 'empty-user-search',
  EMPTY_SEARCH_ICON: 'empty-search',
  EXAMINERS_SEARCH_EMPTY_LIST_ICON: 'examiners-search-empty-list',
  EXPIRE_ICON: 'expire',
  EYE_ICON: 'eye',
  EYE_SLASH_ICON: 'eye-slash',
  FILTER_ICON: 'filter',
  FINANCE_CALENDAR_ICON: 'finance-calendar',
  FINANCE_EXCHANGE_ICON: 'finance-exchange',
  FLAG_ICON: 'flag',
  FOLDERS_ICON: 'folders',
  GRAPH_ANALYTICS_SQUARE_ICON: 'graph-analitycs-square',
  HEADPHONES_ICON: 'headphones',
  HEALTH_ICON: 'health',
  HOSPITAL_BOARD_SQUARE_ICON: 'hospital-board-square',
  HOSPITAL_BUILDING_ICON: 'hospital-building',
  INFO_CIRCLE_ICON: 'info-circle',
  INTERFACE_CALENDAR_ICON: 'interface-calendar',
  INTERFACE_SCHEDULE_ICON: 'interface-schedule',
  INVOICE_ACCOUNTING_CHECKMARK_ICON: 'invoice-accounting-checkmark',
  LINK_BIG_ICON: 'link-big',
  LOCK_ICON: 'lock',
  LOGO_ICON: 'logo',
  MAP_PACKAGE_BOX_ICON: 'map-package-box',
  MEDICAL_CASE_ICON: 'medical-case',
  MEDICAL_CROSS_ICON: 'medical-cross',
  MEDICINE_RECORD_NOTES_ICON: 'medicine-record-notes',
  MEDIUM_ICON: 'medium',
  MENU_LIST_SQUARE_ICON: 'menu-list-square',
  MESSAGES_ICON: 'messages',
  MONEYBAG_ICON: 'moneybag',
  MONITOR_HEART_BEAT_ICON: 'monitor-heart-beat',
  MY_TASKS_EMPTY_LIST_ICON: 'my-tasks-empty-list',
  ON_HOLD_ICON: 'on-hold',
  OPT_ICO_ICON: 'opt-icon',
  PAYMENTS_ICON: 'payments',
  PEN_EDIT_ICON: 'pen-edit',
  PERSON_ICO_ICON: 'person-icon',
  PERSON_ICON: 'person',
  PHONE_NUMBER_ICO_ICON: 'phone-number-icon',
  PIN_ICON: 'pin',
  PLUS_ICON: 'plus',
  PLUS_WITH_CIRCLE_ICON: 'plus-with-circle',
  POLICY_ICON: 'policy',
  PEN: 'pen',
  REFRESH_ROTATE_CIRCLE_ICON: 'refresh-rotate-circle',
  REJECT_CHECK_ICON: 'reject-check',
  REMAINING_DAYS_ICON: 'remaining-days',
  RHOMBUS_ICON: 'rhombus',
  ROUNDED_USER_PROFILE_ICON: 'rounded-user-profile',
  SCHEDULE_CALENDAR_ICON: 'schedule-calendar',
  SEARCH_ICON: 'search',
  SEARCH_CLEAR_ICON: 'search-clear',
  SECURITY_ROLE_ICO_ICON: 'security-role-icon',
  SECURITY_ICON: 'security',
  SELECT_DROPDOWN_ICON: 'select-dropdown',
  SETTING_CIRCLE_ICON: 'setting-circle',
  SETTINGS_ICON: 'settings',
  SINGLE_USER_UPLOAD_ICON: 'single-user-upload',
  SMARTPHONE_CREDIT_ICON: 'smartphone-credit',
  SORTING_ICON: 'sorting',
  STAR_ICON: 'star',
  SUCCESS_ICON: 'success',
  SUPPORT_ICON: 'support',
  TIME_ICON: 'time',
  TIMER_CLOCK_SQUARE_ICON: 'timer-clock-square',
  TIMER_PAUSE_CLOCK_CIRCLE_ICON: 'timer-pause-clock-circle',
  UNASSIGNED_QUEUE_EMPTY_LIST_ICON: 'unassigned-queue-empty-list',
  USER_LIST_ICO_ICON: 'user-list-icon',
  USER_PROFILE_BENEFICIARY_LIST_ICON: 'user-profile-beneficiary-list',
  USER_PROFILE_BENEFICIARY_ICON: 'user-profile-beneficiary',
  USER_PROFILE_CARDS_ICON: 'user-profile-cards',
  USER_PROFILE_LOCATIONS_ICON: 'user-profile-location',
  USER_PROFILE_REPORTER_ICON: 'user-profile-reporter',
  USER_PROFILE_MINI_TIME_CLOCK_ICON: 'user-profile-time-clock',
  USER_PROFILE_ICON: 'user-profile',
  USER_SINGLE_SELECT_ICON: 'user-single-select',
  USER_SINGLE_ICON: 'user-single',
  USER_STATUS_CHECK_ICON: 'user-status-check',
  VECTOR_ICON: 'vector',
  VERIFICATION_ICO_ICON: 'verification-icon',
  WARNING_ICON: 'warning',
  CHAT_ICON: 'chat',
  CARDS_ICON: 'cards-icon',
  FINGER_PRINT_ICON: 'finger-print-icon',
  HEALTH_SHIELD_ICON: 'health-shield-icon',
  HEART_BEAT_ICON: 'heart-beat-icon',
  HOME_ICON: 'home-icon',
  PHARMACY_ICON: 'pharmacy-icon',
  POTENTIAL_MATCHING: 'potential-matching',
  ISSUE_DATE_ICON: 'issue-date-icon',
  MATCH_TYPE_ICON: 'match-type-icon',
  PAID_TO_DATE_ICON: 'paid-to-date-icon',
  QUESTIONMARK_CIRCLE_ICON: 'questionmark-circle-icon',
  STATE_ICON: 'state-icon',
  SIGNATURE_ICON: 'signature',
  AVATAR_MODIFIED_ICON: 'modified-icon',
  PASSWORD_ICON: 'password-icon',
  UMBRELLA_ICON: 'umbrella',
  PIG_ICON: 'pig',
  TRASH_BIN_ICON: 'trash_bin',
  UNLINK_ICON: 'unlink',
  EDITED_FIELD_ICON: 'edited-field',
  VALIDATION_ERROR_ICON: 'validation-error',
  VALIDATION_WARNING_ICON: 'validation-warning',
  VALIDATION_INFO_ICON: 'validation-info',
  LINKED_ENTITIES_ICON: 'linkedEntities',
  PENDING_ICON: 'pending',
  THREE_DOTS_ICON: 'three-dots',
  EDIT_ICON: 'edit-icon',
  EXPAND_DOWN_ICON: 'expand_down',
  EXPAND_UP_ICON: 'expand_up',
  READ_ICON: 'readIcon',
  COPY_ICON: 'copy-icon',
  RETRY_CREATION_ICON: 'retry-creation',
  RESEND_ACTIVATION_ICON: 'resend-activation',
  USER_PROFILE_STATUS: 'user-profile-status',
  VERSION_ICON: 'version',
  ZOOM_PLUS_ICON: 'zoom-plus-icon',
  ZOOM_MINUS_ICON: 'zoom-minus-icon',
  PRINTER_ICON: 'printer-icon',
  SIMPLE_PLUS_ICON: 'simple-plus',
  PARAMETERS_ICON: 'parameters',
  LINK_ICON: 'link',
  OVERRIDE_ICON: 'override-icon',
  PAYMENT_INFO_ICON: 'payment-info',
  ADDRESS_ICON: 'address',
  QUEUE_ICON: 'queue-icon',
};

export const stateFlagIconMap = {
  ALABAMA_ICON: 'alabama',
  ALASKA_ICON: 'alaska',
  ALBERTA_ICON: 'alberta',
  ARCANSAS_ICON: 'arcansas',
  ARKANSAS_ICON: 'arcansas',
  ARIZONA_ICON: 'arizona',
  BRITISH_COLUMBIA_ICON: 'british-columbia',
  CALIFORNIA_ICON: 'california',
  COLORADO_ICON: 'colorado',
  COLUMBIA_ICON: 'columbia',
  CONNECTICUT_ICON: 'connecticut',
  DELVARE_ICON: 'delvare',
  DELAWARE_ICON: 'delvare',
  FLORIDA_ICON: 'florida',
  GEORGIA_ICON: 'georgia',
  HAWAII_ICON: 'hawaii',
  IDAHO_ICON: 'idaho',
  ILLINOIS_ICON: 'illinois',
  INDIANA_ICON: 'indiana',
  IOWA_ICON: 'Iowa',
  KANSAS_ICON: 'kansas',
  KENTUCKY_ICON: 'kentucky',
  LUISIANA_ICON: 'luisiana',
  LOUISIANA_ICON: 'luisiana',
  MAINE_ICON: 'maine',
  MANITOBA_ICON: 'manitoba',
  MARYLAND_ICON: 'maryland',
  MASSACHUSETTS_ICON: 'massachusetts',
  MICHIGAN_ICON: 'michigan',
  MINNESOTA_ICON: 'minnesota',
  MISSISSIPPI_ICON: 'mississippi',
  MISSOURI_ICON: 'missouri',
  MONTANA_ICON: 'montana',
  NEBRASKS_ICON: 'nebrasks',
  NEBRASKA_ICON: 'nebrasks',
  NEVADA_ICON: 'nevada',
  NEW_BRUNSWICK_ICON: 'new-brunswick',
  NEW_HAMPSHIRE_ICON: 'new-hampshire',
  NEW_JERSEY_ICON: 'new-jersey',
  NEW_MEXICO_ICON: 'new-mexico',
  NEW_YORK_ICON: 'new-york',
  NEWFOUNDLAND_ICON: 'newfoundland',
  NEWFOUNDLAND_AND_LABRADOR_ICON: 'newfoundland',
  NORTH_CAROLINA_ICON: 'north-carolina',
  NORTH_DAKOTA_ICON: 'north-dakota',
  NORTHWEST_TERRITORIES_ICON: 'northwest-territories',
  NOVA_SCOTIA_ICON: 'nova-scotia',
  NUNAVUT_ICON: 'nunavut',
  OHIO_ICON: 'ohio',
  OKLAHOMA_ICON: 'oklahoma',
  ONTARIO_ICON: 'ontario',
  OREGON_ICON: 'oregon',
  PENNSYLVANIA_ICON: 'pennsylvania',
  PRINCE_EDWARD_ISLAND_ICON: 'prince-edward-island',
  QUEBEC_ICON: 'quebec',
  RHODE_ISLAND_ICON: 'rhode-island',
  SASKATCHEWAN_ICON: 'saskatchewan',
  SOUTH_CAROLINA_ICON: 'south-carolina',
  SOUTH_DAKOTA_ICON: 'south-dakota',
  TENNESSEY_ICON: 'tennesseу',
  TENNESSEE_ICON: 'tennesseу',
  TEXAS_ICON: 'texas',
  UTAH_ICON: 'utah',
  VERMONT_ICON: 'vermont',
  VIRGINIA_ICON: 'virginia',
  WASHINGTON_ICON: 'washington',
  WEST_VERGINIA_ICON: 'west-verginia',
  WEST_VIRGINIA_ICON: 'west-verginia',
  WISCONSIN_ICON: 'wisconsin',
  WYOMING_ICON: 'wyoming',
  YUKON_ICON: 'yukon',
};

export const documentFormatIconMap = {
  CSV_ICON: 'csv',
  DOC_ICON: 'doc',
  DOCX_ICON: 'docx',
  JPEG_ICON: 'jpeg',
  JPG_ICON: 'jpg',
  PDF_ICON: 'pdf',
  ODS_ICON: 'ods',
  ODT_ICON: 'odt',
  PNG_ICON: 'png',
  RTF_ICON: 'rtf',
  TXT_ICON: 'txt',
  XLS_ICON: 'xls',
  XLSX_ICON: 'xlsx',
};

export type IconCode = keyof (typeof iconMap & typeof stateFlagIconMap & typeof documentFormatIconMap) | null;
